export default "__VITE_ASSET__BZY0L1By__"